
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/bustia-denuncia",
      function () {
        return require("private-next-pages/3catinfo/bustia-denuncia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/bustia-denuncia"])
      });
    }
  